<script setup lang="ts">
import { onMounted, ref } from 'vue';
import type ClubAccessSettings from '../../js/dto/club/ClubAccessSettings.js';
import ClubRepository from '../../js/repository/ClubRepository.js';
import Error from '../../js/model/Error.js';
import KgrAccessSettingsForm from '../../components/club/settings/AccessSettingsForm.vue';
import KgrFormScaffold from '../../components/common/form/FormScaffold.vue';
import KgrLoading from '../../components/common/Loading.vue';
import { useNotifications } from '@/composables/notifications';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<{
    clubId: number
}>();

const { notify } = useNotifications();
const loading = ref(true);
const pending = ref(false);
const error = ref(new Error());
const accessSettings = ref<ClubAccessSettings | null>(null);

onMounted(() => {
    load();
});

function load() {
    ClubRepository.getAccessSettings(props.clubId)
        .then((response) => accessSettings.value = response)
        .catch((err) => {
            error.value = err;
            notify.error('error.loadingData');
        })
        .finally(() => loading.value = false);
}

function updateSettings() {
    pending.value = true;
    ClubRepository.updateAccessSettings(props.clubId, accessSettings.value)
        .then(() => {
            error.value = new Error();
            notify.success('saveChanges.success');
            pending.value = false;
            load();
        })
        .catch((err) => {
            error.value = err;
            notify.error('saveChanges.error');
            pending.value = false;
        });
}
</script>

<template>
    <kgr-form-scaffold
        :pending="loading || pending"
        :with-back-button="false"
        @primary-btn-clicked="updateSettings"
    >
        <kgr-loading v-if="loading" />
        <div
            v-else-if="accessSettings"
            class="kgr-row"
        >
            <kgr-access-settings-form
                v-model:access-settings="accessSettings"
                :club-id="clubId"
                :error="error"
                class="animated fadeIn"
            />
        </div>
    </kgr-form-scaffold>
</template>

<style scoped lang="scss" rel="stylesheet/scss"></style>
